import React from 'react';

export const ButtonOption = ({ value, id, ...rest }) => {
  return (
    <>
      <input
        type="radio"
        value={value}
        id={id}
        {...rest}
      />
      <label htmlFor={id}>{value}</label>
    </>
  )
}